import Vue from 'vue';
import Router from 'vue-router';
import store from '../store/index';

import Frontpage from '../components/layouts/Frontpage';
import AboutProject from '../components/layouts/AboutProject';
import AboutHelp from '../components/layouts/AboutHelp';
import UserAgreement from '../components/layouts/UserAgreement';
import AboutOis from '../components/layouts/AboutOis';
import AboutOrganizations from '../components/layouts/AboutOrganizations';
import AboutTeam from '../components/layouts/AboutTeam';
import AboutExperts from '../components/layouts/AboutExperts';
import AboutMentors from '../components/layouts/AboutMentors';
import Page404 from '../components/layouts/Page404';
import Page403 from '../components/layouts/Page403';
import ObjectsSearch from '../components/layouts/ObjectsSearch';
import UserProfileView from '../components/layouts/UserProfileView';
import UserBookmarks from '../components/layouts/UserBookmarks';
import UserUsers from '../components/layouts/UserUsers';
import ObjectAdd from '../components/layouts/ObjectAdd';
import ObjectFull from '../components/layouts/ObjectFull';
import ObjectCertificate from '../components/layouts/ObjectCertificate';
import UserObjects from '../components/layouts/UserObjects';
import UserRecommendations from '../components/layouts/UserRecommendations';
import UserDrafts from '../components/layouts/UserDrafts';
import UserDeals from '../components/layouts/UserDeals';
import UserEvents from '../components/layouts/UserEvents';
import UserRegister from '../components/layouts/UserRegister';
import UserProfile from '../components/layouts/UserProfile';
import UserSubscriptions from '../components/layouts/UserSubscriptions';
import UserOrg from '../components/layouts/org-admin/UserOrg';
import UserOrgUsers from '../components/layouts/org-admin/UserOrgUsers';
import UserOrgUsersList from '../components/layouts/org-admin/UserOrgUsersList';
import UserOrgObjects from '../components/layouts/org-admin/UserOrgObjects';
import UserOrgObjectsConfirm from '../components/layouts/org-admin/UserOrgObjectsConfirm';
import UserOrgDeals from '../components/layouts/org-admin/UserOrgDeals';
import UserOrgClaims from '../components/layouts/org-admin/UserOrgClaims';
import UserRecoverPassInit from '../components/layouts/UserRecoverPassInit';
import UserRecoverPassChange from '../components/layouts/UserRecoverPassChange';
import UserAuthenticate from '../components/layouts/UserAuthenticate';
import ObjectSearchForm from '../components/ObjectSearchForm';
import Hexagons from '../components/Hexagons';
import FrontStat from '../components/FrontStat';

Vue.use(Router);
const nextDelay = 100;

const router = new Router({
  mode: 'history',
  routes: [
    {
      path: '/',
      component: Frontpage,
      children: [
        {
          path: '',
          components: {
            form: ObjectSearchForm,
            stat: FrontStat,
            default: Hexagons,
          },
        },
        {
          path: 'by-types',
          components: {
            form: ObjectSearchForm,
            stat: FrontStat,
            default: Hexagons,
          },
        },
        {
          path: 'by-org/:orgId',
          components: {
            form: ObjectSearchForm,
            stat: FrontStat,
            default: Hexagons,
          },
        },
        {
          path: 'objects/search',
          components: {
            form: ObjectSearchForm,
            default: ObjectsSearch,
          },
        },
      ],
    },
    { path: '/about-project', component: AboutProject },
    { path: '/help/:helpId', component: AboutHelp },
    { path: '/user-agreement', component: UserAgreement },
    { path: '/about-ois', component: AboutOis },
    { path: '/about-organizations', component: AboutOrganizations },
    { path: '/about-team', component: AboutTeam },
    { path: '/about-experts', component: AboutExperts },
    { path: '/about-mentors', component: AboutMentors },
    { path: '/404', component: Page404 },
    { path: '/403', component: Page403 },
    {
      path: '/objects/add',
      component: ObjectAdd,
      beforeEnter(to, from, next) {
        const timeout = (from.path === '/') ? nextDelay : 0;
        setTimeout(() => {
          if (!store.getters['user/isAuthenticated']) {
            next('/user/authenticate');
          } else {
            next();
          }
        }, timeout);
      },
    },
    {
      path: '/object/edit/:objectId',
      component: ObjectAdd,
      beforeEnter(to, from, next) {
        const timeout = (from.path === '/') ? nextDelay : 0;
        setTimeout(() => {
          if (!store.getters['user/isAuthenticated']) {
            next('/user/authenticate');
          } else {
            next();
          }
        }, timeout);
      },
    },
    {
      path: '/object/:objectId/certificate',
      component: ObjectCertificate,
    },
    {
      path: '/object/:objectId',
      component: ObjectFull,
    },
    {
      path: '/user/:userId/profile/view',
      component: UserProfileView,
    },
    {
      path: '/user/bookmarks',
      component: UserBookmarks,
      beforeEnter(to, from, next) {
        const timeout = (from.path === '/') ? nextDelay : 0;
        setTimeout(() => {
          if (!store.getters['user/isAuthenticated']) {
            next('/user/authenticate');
          } else {
            next();
          }
        }, timeout);
      },
    },
    {
      path: '/user/users',
      component: UserUsers,
      beforeEnter(to, from, next) {
        const timeout = (from.path === '/') ? nextDelay : 0;
        setTimeout(() => {
          if (!store.getters['user/isAuthenticated']) {
            next('/user/authenticate');
          } else {
            next();
          }
        }, timeout);
      },
    },
    {
      path: '/user/objects',
      component: UserObjects,
      beforeEnter(to, from, next) {
        const timeout = (from.path === '/') ? nextDelay : 0;
        setTimeout(() => {
          if (!store.getters['user/isAuthenticated']) {
            next('/user/authenticate');
          } else {
            next();
          }
        }, timeout);
      },
    },
    {
      path: '/user/recommendations',
      component: UserRecommendations,
      beforeEnter(to, from, next) {
        const timeout = (from.path === '/') ? nextDelay : 0;
        setTimeout(() => {
          if (!store.getters['user/isAuthenticated']) {
            next('/user/authenticate');
          } else {
            next();
          }
        }, timeout);
      },
    },
    {
      path: '/user/drafts',
      component: UserDrafts,
      beforeEnter(to, from, next) {
        const timeout = (from.path === '/') ? nextDelay : 0;
        setTimeout(() => {
          if (!store.getters['user/isAuthenticated']) {
            next('/user/authenticate');
          } else {
            next();
          }
        }, timeout);
      },
    },
    {
      path: '/user/deals',
      component: UserDeals,
      beforeEnter(to, from, next) {
        const timeout = (from.path === '/') ? nextDelay : 0;
        setTimeout(() => {
          if (!store.getters['user/isAuthenticated']) {
            next('/user/authenticate');
          } else {
            next();
          }
        }, timeout);
      },
    },
    {
      path: '/user/events',
      component: UserEvents,
      beforeEnter(to, from, next) {
        const timeout = (from.path === '/') ? nextDelay : 0;
        setTimeout(() => {
          if (!store.getters['user/isAuthenticated']) {
            next('/user/authenticate');
          } else {
            next();
          }
        }, timeout);
      },
    },
    {
      path: '/user/register',
      component: UserRegister,
      beforeEnter(to, from, next) {
        const timeout = (from.path === '/') ? nextDelay : 0;
        setTimeout(() => {
          if (store.getters['user/isAuthenticated']) {
            next('/user/profile');
          } else {
            next();
          }
        }, timeout);
      },
    },
    {
      path: '/user/profile',
      component: UserProfile,
      beforeEnter(to, from, next) {
        const timeout = (from.path === '/') ? nextDelay : 0;
        setTimeout(() => {
          if (!store.getters['user/isAuthenticated']) {
            next('/user/authenticate');
          } else {
            next();
          }
        }, timeout);
      },
    },
    {
      path: '/user/subscriptions',
      component: UserSubscriptions,
      beforeEnter(to, from, next) {
        const timeout = (from.path === '/') ? nextDelay : 0;
        setTimeout(() => {
          if (!store.getters['user/isAuthenticated']) {
            next('/user/authenticate');
          } else {
            next();
          }
        }, timeout);
      },
    },
    {
      path: '/user/authenticate',
      component: UserAuthenticate,
      beforeEnter(to, from, next) {
        const timeout = (from.path === '/') ? nextDelay : 0;
        setTimeout(() => {
          if (store.getters['user/isAuthenticated']) {
            next('/user/objects');
          } else {
            next();
          }
        }, timeout);
      },
    },
    {
      path: '/user/recover-pass',
      component: UserRecoverPassInit,
      beforeEnter(to, from, next) {
        const timeout = (from.path === '/') ? nextDelay : 0;
        setTimeout(() => {
          if (store.getters['user/isAuthenticated']) {
            next('/user/objects');
          } else {
            next();
          }
        }, timeout);
      },
    },
    {
      path: '/user/recover-pass/:hash',
      component: UserRecoverPassChange,
      beforeEnter(to, from, next) {
        const timeout = (from.path === '/') ? nextDelay : 0;
        setTimeout(() => {
          if (store.getters['user/isAuthenticated']) {
            next('/user/objects');
          } else {
            next();
          }
        }, timeout);
      },
    },
    {
      path: '/user/organization/:orgId',
      component: UserOrg,
    },
    {
      path: '/user/organization/:orgId/users',
      component: UserOrgUsers,
    },
    {
      path: '/user/organization/:orgId/users/list',
      component: UserOrgUsersList,
    },
    {
      path: '/user/organization/:orgId/objects',
      component: UserOrgObjects,
    },
    {
      path: '/user/organization/:orgId/objects/confirm',
      component: UserOrgObjectsConfirm,
    },
    {
      path: '/user/organization/:orgId/deals',
      component: UserOrgDeals,
    },
    {
      path: '/user/organization/:orgId/claims',
      component: UserOrgClaims,
    },
  ],
});

router.beforeEach((to, from, next) => {
  if (!to.matched.length) {
    next('/404');
  }
  // Prevent user with no OBJECT_CREATE permission to visit /objects/add page
  if (to.path === '/objects/add') {
    const userData = store.getters['user/getUserData'];
    if (userData && !userData.Transient.Permissions.OBJECT_CREATE) {
      store.commit('setShowDepoAccessDenied', true);
      return;
    }
  }
  next();
});

router.afterEach((to) => {
  // Set some pages as form pages with colorful background
  const formPages = [
    '/user/authenticate',
    '/user/profile',
    '/user/register',
    '/user/recover-pass',
    '/user/recover-pass/[0-9a-f]+',
    '/user/organization/[\\w\\d]+',
    // '/object/certificate/[0-9a-z.A-Z-]+',
    '/objects/add',
    '/object/edit/[0-9a-z.A-Z-]+',
  ];
  let found = false;
  formPages.forEach((fp) => {
    const pattern = new RegExp(`^${fp}$`);
    if (to.path.match(pattern) !== null) {
      found = true;
      document.getElementsByTagName('html')[0].classList.add('html_page-form');
    }
  });
  if (!found) {
    document.getElementsByTagName('html')[0].classList.remove('html_page-form');
  }
});

export default router;



// WEBPACK FOOTER //
// ./src/router/index.js